import React from "react";
import { Container, Row, Col } from "reactstrap";
import PrivacySection from "./PrivacyPolicy";
import '../../assets/css/termsconditions.css';

export default function PrivacyPolicy() {
    return (
        <Container className="terms-container my-5">
            <Row>
                <Col lg="12">
                    <h1 className="mb-5 pb-3 fw-bold text-primary text-center">Privacy Policy</h1>
                    <PrivacySection />
                </Col>
            </Row>
        </Container>
    );
}
